import { useEffect, useState, useCallback } from "react";
import { Box, Button, Container, Typography, Dialog, DialogTitle, DialogContent, DialogActions, useMediaQuery, MenuItem, TextField,} from "@mui/material";
import { DataGrid, gridPageCountSelector, gridPageSelector, useGridSelector, useGridApiRef  } from "@mui/x-data-grid";
import { Diversity3 } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { callPostApi } from "../../API/ApiCallFunction";
import GradientLoader from "../../CommanComponents/GradientLoader";
import ReusableDialog from "../../CommanComponents/ReusableDialog";
import { useLocation, useNavigate } from "react-router-dom";
import {Pagination,  PaginationItem, } from "@mui/material";

function CustomToolbar({ onAddCampaign }) {
  return (
    <Box> <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={onAddCampaign}> Campaign </Button> </Box>
    );}

function CustomPagination({ apiRef, isMobile }) {
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  const handlePageChange = (_, value) => {
    apiRef.current.setPage(value - 1);

    if (isMobile && apiRef.current) {
      setTimeout(() => {
        apiRef.current.autosizeColumns({ includeHeaders: true });
      }, 0);
    }
  }; return (
    <Pagination color="primary" variant="outlined" shape="rounded"
      page={page + 1}
      count={pageCount}
      renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
      onChange={handlePageChange}
    />
  );
}


export function DashboardSaleReport() {
  const apiRef = useGridApiRef();
  const isMobile = useMediaQuery("(max-width:768px)");
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [openD, setOpenD] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [datar, setDatar] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filterLimit, setFilterLimit] = useState(100);
  const [paginationModel, setPaginationModel] = useState({ pageSize: 10, page: 0,});
  const handleAddCampaign = () => setOpen(true);
  const handleClose = () => setOpen(false);
   const location = useLocation();
  const { startdate, enddate } = location.state || {};
  const columns = [
    { field: "id", headerName: "Sr no.", flex: 0.5 },
    { field: "order_amount", headerName: "Order Amount", flex:1,},
    { field: "customer_name", headerName: "Customer Name", flex: 1,},
    { field: "date_added", headerName: "Date Added", flex: 1 },
    // { field: "pay_status", headerName: "Pay Status", flex: 1 },
    { field: "payment_type", headerName: "Payment Type", flex: 1 },
    { field: "customer_mobile", headerName: "Customer Mobile", flex: 1 },
 ];

  const formatDates = (dateString) => {
  if (!dateString) return "";

  const [year, month, day] = dateString.split("-");
  return `${day}-${month}-${year}`; 
};
  // API call
  const customerListApi = useCallback(async () => {
    try {
      setLoading(true);
      const storeid = user.store_info?.store_id;
      const payload = { mod: "CASHI_SALE_REPORT", data_arr: { store_id: storeid,startDate:startdate,endDate:enddate, start: 0, limit: 500,}, };
      
      const apiResult = await callPostApi("store-cashi-report", payload);
console.log(JSON.stringify(apiResult));

      if (apiResult.status === "200" && Array.isArray(apiResult.data)) { 
        const formattedData = apiResult.data.map((item, index) => ({
          id: index + 1,
          order_amount: "₹ "+item.order_amount || "NA",
          date_added: item.date_added || "NA",
          customer_name: item.customer_name || "NA",
          pay_status: item.pay_status || "NA",
          customer_mobile: item.customer_mobile || "NA",
          payment_type: item.payment_type || "NA",
        }));
        setDatar(formattedData);
      } else { setDatar([]);}
    } finally { setLoading(false);}
  },[user.store_info?.store_id, filterLimit]);

  useEffect(() => {
    customerListApi(paginationModel.page, paginationModel.pageSize);
  }, [paginationModel.page, paginationModel.pageSize, customerListApi]);

  return (
    <Container sx={{ my: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "start", mb: 2 }}>
        <Button  variant="contained"  sx={{ backgroundColor: "#000000", color: "#ffffff" }} onClick={() => navigate(-1)}>
          Back
        </Button>
      </Box>

      {/* Title */}
      <Typography ariant="h6" gutterBottom sx={{ background: "linear-gradient(195deg, #49a3f1, #1A73E8)",  p: 1, color: "#ffffff",
        borderRadius: "4px", mb: 3, display: "flex", alignItems: "center",}}> <Diversity3 sx={{ mr: 1 }} /> Total Customer
      </Typography>

      {/* Toolbar */}
      <Box sx={{ mb: 2, display: "flex", justifyContent: "end" }}> <CustomToolbar onAddCampaign={handleAddCampaign} /></Box>
      <Box sx={{my:2}}>
         <TextField  select label="Limit" value={filterLimit} onChange={(e) => { setFilterLimit(e.target.value);}}
           sx={{ minWidth: 140, }}>
           <MenuItem value={100}>100</MenuItem>
           <MenuItem value={300}>300</MenuItem>
           <MenuItem value={500}>500</MenuItem>
           <MenuItem value={2000}>All</MenuItem>
         </TextField>
         <Button variant="outlined" color="primary"  sx={{ height: 56 , mx:1}} onClick={() => { customerListApi();}}>
           Apply Filter </Button>

              <Button variant="outlined" color="primary"  sx={{ height: 56 , mx:1}}>
          Date : {formatDates(startdate) } to {formatDates(enddate)} </Button>
       </Box>

      {/* DataGrid */}
      <Box sx={{ height: "auto", width: "100%", mb: 4 }}>
        <DataGrid apiRef={apiRef} rows={datar} columns={columns} disableRowSelectionOnClick checkboxSelection showToolbar
          paginationModel={paginationModel} onPaginationModelChange={setPaginationModel}  getRowHeight={() => "auto"}
          slots={{ pagination: () => <CustomPagination apiRef={apiRef} isMobile={isMobile} />,}}
          sx={{
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal",
              wordBreak: "break-word",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#f0f0f0",
              color: "#000",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: 14,
              fontWeight: 600,
              whiteSpace: "normal",
              wordBreak: "break-word",
            },
          }}
        />
      </Box>

 
      <ReusableDialog open={open} onClose={handleClose} />   {/* Add Campaign Dialog */}
      <Dialog open={openD} onClose={() => setOpenD(false)} maxWidth="sm" fullWidth sx={{ overflowY: "auto" }} >
        <Box> {selectedRow ? (
          <>
           <DialogTitle sx={{ background: "linear-gradient(195deg, #49a3f1, #1A73E8)", color: "#fff",}} >
              <Typography variant="h6"> {selectedRow.customer_name}</Typography>
            </DialogTitle>
            <DialogContent>
              <Typography>Total Visits: {selectedRow.total_visit}</Typography>
              <Typography>Order (₹): {selectedRow.order_amount}</Typography>
              <Typography>Payment (₹): {selectedRow.payment}</Typography>
              <Typography>Loyalty Points: {selectedRow.loyalty}</Typography>
              <Typography> Balance Points: {selectedRow.balance_point}</Typography>
            </DialogContent>
            <DialogActions> 
              <Box sx={{ textAlign: "right", mt: 2 }}><Button onClick={() => setOpenD(false)} variant="contained"> Close </Button></Box>
            </DialogActions>
            </>
             ) : ( <Typography>No details available</Typography>)}
        </Box>
      </Dialog>

      {loading && <GradientLoader text="Loading" />}   {/* Loader */}
    </Container>
  );
}